import theme from '@styles/theme';
export default {
  inspirationMultiSection: (bg: string) => ({
    bg,
    display: ['block', 'block', 'block', 'flex'],
    justifyContent: 'center',
    position: 'relative',
    alignItems: 'center',
    flexWrap: ['wrap', 'wrap', 'wrap', 'nowrap'],
    rowGap: 40,
    p: [0, 0, 0, '0 2.083333333vw'],
    columnGap: '1.25vw',
    zIndex: theme.zIndex.documentUp
  })
};